
    <!-- Button to buy tickets if establishment.group is 'checkout' -->
      <button
        *ngIf="establishment.group === 'checkout'"
        class="btn"
        (click)="handleButtonClick()"
        [disabled]="loading"
      >
        <i aria-hidden="true" class="fa fa-ticket" *ngIf="!loading"></i>
        <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
        COMPRAR
      </button>


    <!-- Coupon generate button if establishment.group is not 'checkout' and no coupon exists -->
    <footer
      class="text-center"
      *ngIf="
        establishment.group !== 'checkout' && establishment.group == 'coupon'
      "
    >
      <button class="btn" (click)="generateCoupon()">
        <i class="fa fa-ticket" aria-hidden="true"></i> Gerar cupom
      </button>
    </footer>

    <!-- Display the generated coupon if it exists and establishment.group is not 'checkout' -->
    <span
      class="bar-space"
      *ngIf="
        establishment.group !== 'checkout' &&
        !partnership?.site &&
        coupon != null
      "
    ></span>
    <div
      class="coupon-wrapper"
      *ngIf="
        establishment.group !== 'checkout' &&
        !partnership?.site &&
        coupon != null
      "
    >
      <p><i class="fa fa-ticket" aria-hidden="true"></i> {{ coupon }}</p>
    </div>

    <!-- Link to partnership site if applicable and establishment.group is not 'checkout' -->
    <footer
      class="text-center"
      *ngIf="establishment.group !== 'checkout' && partnership?.site"
    >
      <a target="_blank" [href]="'http://' + partnership.site" class="btn">
        <i class="fa fa-ticket" aria-hidden="true"></i>Visitar site
      </a>
    </footer>

    <!-- Modals -->
    <ng-core-modal #modalApp>
      <div class="flex">
        <div class="block">
          <h3 class="title">
            Ops! Parece que você está tentando comprar ingressos pelo navegador!
          </h3>
          <p class="description">
            A partir de agora, para oferecer uma experiência ainda melhor e mais
            personalizada, a compra de ingressos de cinema está disponível
            exclusivamente no nosso aplicativo.
          </p>
          <p class="description">
            <a href="https://allyaapp.page.link/tag-checkout" class="link"
              >Clique aqui</a
            >
            ou acesse o QR code para acessar o app.
          </p>
          <p class="description">
            Para mais informações acesse nossa
            <a class="link" href="https://ajuda.allya.com.br/pt-BR/"
              >Central de Ajuda!</a
            >
          </p>
        </div>
        <div class="block-image">
          <img src="assets/shared/img/qr-code.png" />
          <div class="aux-image">
            <a
              href="https://play.google.com/store/apps/details?id=com.allyaapp&hl=pt_BR&gl=US&pli=1"
            >
              <img src="assets/shared/img/google-play.png" />
            </a>
            <a href="https://apps.apple.com/br/app/allya/id1398933563">
              <img src="assets/shared/img/apple-app.png" />
            </a>
          </div>
        </div>
      </div>
    </ng-core-modal>

    <ng-core-modal #modalRegister [config]="modalConfig" class="modal-cpf">
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <p class="description-modal">
          Antes de continuar, por favor, insira seu CPF. Isso nos ajuda a
          garantir uma experiência tranquila e segura para você.
        </p>
        <div class="form-group">
          <input
            type="text"
            id="cpf"
            placeholder="CPF"
            formControlName="cpf"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.cpf.errors }"
            (input)="onInput($event)"
            maxlength="14"
          />
          <div *ngIf="submitted && f.cpf.errors" class="invalid-feedback">
            <div class="error-text" *ngIf="f.cpf.errors.required">
              CPF é obrigatório
            </div>
            <div class="error-text" *ngIf="f.cpf.errors.pattern">
              CPF inválido
            </div>
          </div>
        </div>
        <div class="buttons">
          <button type="button" class="btn-cancelar" (click)="onCancel()">
            Cancelar
          </button>
          <button type="submit" class="btn-cadastrar">Cadastrar</button>
        </div>
      </form>
    </ng-core-modal>
  